import { useLocation } from 'react-router-dom';
import React from 'react';

export const MetaTagsManager = () => {
  const location = useLocation();

  // Add additional meta tags for better SEO (client-side only)
  React.useEffect(() => {
    // Only run on client side
    if (import.meta.env.SSR || typeof document === 'undefined') {
      return;
    }

    // Add robots meta tag if not present
    let robotsMeta = document.querySelector('meta[name="robots"]');
    if (!robotsMeta) {
      robotsMeta = document.createElement('meta');
      robotsMeta.setAttribute('name', 'robots');
      robotsMeta.setAttribute('content', 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1');
      document.head.appendChild(robotsMeta);
    }

    // Add googlebot meta tag if not present
    let googlebotMeta = document.querySelector('meta[name="googlebot"]');
    if (!googlebotMeta) {
      googlebotMeta = document.createElement('meta');
      googlebotMeta.setAttribute('name', 'googlebot');
      googlebotMeta.setAttribute('content', 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1');
      document.head.appendChild(googlebotMeta);
    }

    // Add viewport meta tag if not present
    let viewportMeta = document.querySelector('meta[name="viewport"]');
    if (!viewportMeta) {
      viewportMeta = document.createElement('meta');
      viewportMeta.setAttribute('name', 'viewport');
      viewportMeta.setAttribute('content', 'width=device-width, initial-scale=1.0');
      document.head.appendChild(viewportMeta);
    }

    // Add language meta tag
    let langMeta = document.querySelector('meta[http-equiv="content-language"]');
    if (!langMeta) {
      langMeta = document.createElement('meta');
      langMeta.setAttribute('http-equiv', 'content-language');
      langMeta.setAttribute('content', 'en');
      document.head.appendChild(langMeta);
    }

    // Add charset meta tag if not present
    let charsetMeta = document.querySelector('meta[charset]');
    if (!charsetMeta) {
      charsetMeta = document.createElement('meta');
      charsetMeta.setAttribute('charset', 'UTF-8');
      document.head.appendChild(charsetMeta);
    }

  }, [location.pathname]);

  return null;
}; 